var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicketpage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 26,
    viewBox: "0 0 39 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 26,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DM Pass - 1",
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-701 -166)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "DM Pass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ticket",
    d: "M8.66667 6.39488H30.3333V19.1846H8.66667V6.39488ZM35.75 12.7898C35.75 14.5557 37.2051 15.9872 39 15.9872V22.3821C39 24.148 37.5449 25.5795 35.75 25.5795H3.25C1.45505 25.5795 0 24.148 0 22.3821V15.9872C1.79495 15.9872 3.25 14.5557 3.25 12.7898C3.25 11.0238 1.79495 9.59232 0 9.59232V3.19744C0 1.43152 1.45505 0 3.25 0H35.75C37.5449 0 39 1.43152 39 3.19744V9.59232C37.2051 9.59232 35.75 11.0238 35.75 12.7898ZM32.5 5.86198C32.5 4.97902 31.7725 4.26325 30.875 4.26325H8.125C7.22753 4.26325 6.5 4.97902 6.5 5.86198V19.7176C6.5 20.6005 7.22753 21.3163 8.125 21.3163H30.875C31.7725 21.3163 32.5 20.6005 32.5 19.7176V5.86198Z",
    fill: "#0FA453"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-701 -166)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketpage);
export default __webpack_public_path__ + "static/media/ticketpage.960898b185708c0ce9aa8222d8af0cc7.svg";
export { ForwardRef as ReactComponent };